// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row-class:hover {\n  cursor: pointer;\n}\n.pageAlign{\n  float:right;\n}\n", ""]);
// Exports
module.exports = exports;
